import { render, staticRenderFns } from "./notification-center.vue?vue&type=template&id=0e1c1d7e"
import script from "./notification-center.vue?vue&type=script&lang=js"
export * from "./notification-center.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports